// extracted by mini-css-extract-plugin
module.exports = {"term":"AppointmentServiceDescription_term__qjG_g"};